import { useCallback, useEffect, useState } from "react";
import { filter, findIndex, update, append } from 'ramda';

import useAuth from "../../../login/AuthContext";
import API from "../../../../services/Api";

export const useTags = () => {
  const { getAuthToken } = useAuth();
  const [loading, setLoading] = useState(true);
  const [tags, setUsers] = useState([]);

  const loadTags = useCallback(async () => {
    const results = await API.loadTags(await getAuthToken());

    setUsers(results);
    setLoading(false);
  }, []);

  const removeTag = useCallback((tagId) => {
    setUsers(filter(({ id }) => id !== tagId));
  }, []);

  const updateTag = useCallback((tag) => {
    setUsers(tags => {
      const index = findIndex(({ id }) => id === tag.id, tags);
      return update(index, tag, tags);
    });
  }, []);

  const addTag = useCallback((tag) => {
    setUsers(append(tag));
  }, []);

  useEffect(() => {
    loadTags();
  }, []);

  return {
    tags,
    addTag,
    updateTag,
    removeTag,
    loading,
  };
};
